import React, { ReactNode } from 'react';
import { smilyAndPeople } from 'src/constants/smiles';
import ScrollableBlock from 'src/view/containers/ScrollableBlock/ScrollableBlock';
import './style.scss';

interface IProps {
  addSmile: (smile: string) => void;
  children?: ReactNode;
}

interface IState {
  smilesModal: boolean;
}

export default class Smiles extends React.Component<IProps, IState> {
  state = {
    smilesModal: false,
  };

  clickSmile = (smile: string) => {
    this.props.addSmile(smile);
  };

  smilesModal = () => {
    this.setState({ smilesModal: !this.state.smilesModal });
  };

  smilesModalClose = () => {
    this.setState({ smilesModal: false });
  };

  smileRender = (item: string) => {
    return (
      <li key={item} className="smiles__item text-size-18" onClick={() => this.clickSmile(item)}>
        {item}
      </li>
    );
  };

  render() {
    return (
      <div className="smiles">
        <div onClick={this.smilesModal}>{this.props.children}</div>
        {this.state.smilesModal ? (
          <div className="smiles__wrapper">
            <ScrollableBlock showScrollbar scrollbarSize="small" className="full-width">
              <ul className="smiles__container">{smilyAndPeople.map((item) => this.smileRender(item))}</ul>
            </ScrollableBlock>
            <button className="smiles__overlay" onClick={this.smilesModal} />
          </div>
        ) : null}
      </div>
    );
  }
}
